import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueGtag from "vue-gtag";
import "./registerServiceWorker";
import "normalize.css";
import globalStyle from "@/assets/styles/globalStyle.styl";
Vue.config.productionTip = false;

Vue.use(
  VueGtag,
  {
    config: { id: "G-J1G53SPLCL" }
  },
  router
);

new Vue({
  router,
  globalStyle,
  render: h => h(App)
}).$mount("#app");
